module.exports = __webpack_public_path__ + "static/media/FO.2ff9c795.png";